import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=3e71666b&scoped=true&lang=pug"
import script from "./FavoriteButton.vue?vue&type=script&lang=js"
export * from "./FavoriteButton.vue?vue&type=script&lang=js"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&id=3e71666b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71666b",
  null
  
)

export default component.exports